import { useEffect, useState } from "react";
import { Layers } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";

/** Clinician-only threshold for the quiet stuck-stage line. The client never sees it. */
export function StageHeadsupSetting({ onChanged }) {
  const [state, setState] = useState(null);
  useEffect(() => { api.get("/clinician/stage-headsup").then((r) => setState(r.data)).catch(() => {}); }, []);
  const save = async (weeks) => {
    try { const r = await api.patch("/clinician/stage-headsup", { weeks }); setState(r.data); onChanged?.(); toast.success(weeks ? `You'll see a line after ${weeks} weeks on one stage.` : "Stage heads-up turned off."); }
    catch (e) { toast.error("Couldn't save that"); }
  };
  if (!state) return null;
  return (
    <section className="warm-card p-5" data-testid="stage-headsup-setting">
      <div className="flex items-start gap-3">
        <div className="w-9 h-9 rounded-xl bg-stone-100 grid place-items-center shrink-0"><Layers className="w-4 h-4 text-stone-700" /></div>
        <div className="flex-1 min-w-0">
          <div className="font-display font-bold text-stone-900">Stage heads-up</div>
          <p className="text-xs text-stone-600 mt-0.5">Let me know when a member has been on the same stage for</p>
          <div className="flex flex-wrap gap-1.5 mt-2">
            {state.choices.map((w) => (
              <button key={w} onClick={() => save(w)} data-testid={`stage-headsup-choice-${w}`}
                className={`text-xs font-semibold px-3 py-1 rounded-full border transition-colors ${state.weeks === w ? "bg-stone-900 text-white border-stone-900" : "bg-white border-stone-300 text-stone-700 hover:border-stone-500"}`}>
                {w ? `${w} weeks` : "Off"}
              </button>
            ))}
          </div>
          <p className="text-[11px] text-stone-500 mt-2">Shown only to you, under the habit's stage ladder. It clears when the stage moves or when you tap Seen.</p>
        </div>
      </div>
    </section>
  );
}
